<template>
    <v-wait :for="name">
        <template slot="waiting">
            <div class="page-loader">
                <clip-loader :loading="true" color="#cc5100" size="120px" class="center"></clip-loader>
            </div>
        </template>
        <slot />
    </v-wait>
</template>

<script>
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue';

  export default {
    name: 'Loading',
    props: ['name'],
    components: {
      ClipLoader
    }
  };
</script>
